import { Alert } from '@neo/primitives/alert'
import { ButtonWithLoader } from '@neo/primitives/button'
import { useState } from 'react'

interface QueryErrorProps {
  title: string
  onRetry: () => unknown
  testId: string
  isRetrying?: boolean
}

export const QueryError = ({ title, onRetry, testId, isRetrying = false }: QueryErrorProps) => {
  const [retryPending, setRetryPending] = useState(false)
  const handleRetry = async () => {
    setRetryPending(true)
    try {
      await onRetry()
    } catch {
      // The owning query keeps its error state if the retry is rejected.
    } finally {
      setRetryPending(false)
    }
  }

  return (
    <Alert
      variant="destructive"
      title={title}
      content={
        <ButtonWithLoader
          type="button"
          variant="outline"
          size="sm"
          className="mt-2"
          onClick={handleRetry}
          loading={retryPending || isRetrying}
          aria-busy={retryPending || isRetrying}
          data-testid={testId}
        >
          Retry
        </ButtonWithLoader>
      }
    />
  )
}
